import { FunctionComponent } from "react";
import Raptor2Loading from "../../feedback/Raptor2Loading";

interface IframeFallbackProps {
  filename: string;
  isPending: boolean;
}

// The purpose of this comonent is to allow a vnailla iframe viewer fallback if the RaptorPDFViewer fails for some reason
export const IframeFallback: FunctionComponent<IframeFallbackProps> = ({
  filename,
  isPending,
}) => {
  return (
    <>
      <iframe
        src=""
        width={isPending ? '0%' : '100%'}
        height="100%"
        title={`${filename}.pdf`}
      ></iframe>
      {isPending ? (
        <Raptor2Loading centerWrap messages={['Generating Document...']} />
      ) : null}
    </>
  );
};